
import { Box, Flex, Text, Image, Link, VStack, Tag, SimpleGrid } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { useState } from 'react';
import DioProjectMockup from '../images/project_mockups/dioProjectMockup.png';
import CantaloupeProjectMockup from '../images/project_mockups/cantaloupeProjectMockup.png';
import AuraProjectMockup from '../images/project_mockups/auraProjectMockup.png';
import SpeakEasyProjectMockup from '../images/project_mockups/speakEasyProjectMockup.png';
import EarshotProjectMockup from '../images/project_mockups/earshotProjectMockup.png';
import ZenithProjectMockup from '../images/project_mockups/zenithProjectMockup.png';

const MotionBox = motion(Box);

const projects = [
    {
        title: "Dio Mobile App",
        description: "Order and pay for your favorite cocktails, beers, or wines before you arrive at the bar. Walk in, grab your drink, and enjoy your night without the wait.",
        image: DioProjectMockup,
        tags: ["React Native", "Expo", "Postman", "DynamoDB", "Figma", "AWS", "Twilio"],
        link: "/"
    },
    {
        title: "Cantaloupe",
        description: "Cantaloupe goes beyond traditional screening methods, assessing social fit, long-term potential, and specific job requirements to deliver a shortlist of top-tier candidates.",
        image: CantaloupeProjectMockup,
        tags: ["React Native", "Expo", "Stream Chat", "Twilio"],
        link: "https://www.trycantaloupe.com/"
    },
    {
        title: "Earshot: Localized Chatting",
        description: "Earshot revolutionizes social interaction by allowing users to anonymously join location-based chatrooms across the country.",
        image: EarshotProjectMockup,
        tags: ["React Native", "Stream Chat", "Figma", "Twilio"],
        link: "https://apps.apple.com/us/app/earshot-proximity-chat/id6471038992"
    },
    {
        title: "Aura Advertising Client Dashboard",
        description: "Aura is a desktop dashboard designed to provide real-time data analytics for cartop advertisements.",
        image: AuraProjectMockup,
        tags: ["React", "Node.js", "DynamoDB", "Figma", "AWS Amplify", "Bluetooth", "Chart.js"],
        link: "https://dashboard.auraadco.com/"
    },
    {
        title: "Speak Easy Website",
        description: "A custom website for a local band in Baton Rouge, LA. The website features info about the band, upcoming shows, and their music.",
        image: SpeakEasyProjectMockup,
		tags: ["React", "Node.js", "Figma", "AWS Amplify", "Spotify API"],
        link: "https://www.speakeasybandbr.com/"
    },
    {
        title: "Zenith Software Website",
        description: "My company's website, showcasing our services, projects, and team members. Created in 2021, the site shwocases the beginning of our journey.",
        image: ZenithProjectMockup,
        tags: ["HTML", "CSS", "Material Tailwind", "Project Management"],
        link: "https://www.zenithsoftware.dev/"
    },
];

export default function Portfolio() {
	const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

	const isMobile = window.innerWidth <= 768;

	return (
		<Flex
			id="portfolio"
			flexDirection="column"
			padding="5%"
			paddingLeft="10%"
			paddingRight="10%"
			backgroundColor="black.300"
			minW="100%"
		>
			<Text
				fontSize="4xl"
				fontFamily="Source Code Pro Variable"
				fontWeight="600"
				color="white.200"
				marginBottom="5%"
                width={"100%"}
                textAlign={"center"}
			>
				Portfolio
			</Text>

			<SimpleGrid columns={{ base: 1, md: 5 }} spacing={4}>
				{projects.map((project, index) => (
				<MotionBox
					key={index}
					height="300px"
					gridColumn={{ md: getGridColumn(index) }}
					initial={{ opacity: 0, y: 50 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.5, delay: index * 0.1 }}
					onMouseEnter={() => setHoveredIndex(index)}
					onMouseLeave={() => setHoveredIndex(null)}
				>
					<Link href={project.link} isExternal _hover={{ textDecoration: 'none' }} height="100%">
						<Box position="relative" overflow="hidden" borderRadius="lg" height="100%">
							<Image
								src={project.image}
								alt={project.title}
								objectFit="cover"
								width="100%"
								height="100%"
								transition="transform 0.3s ease"
								transform={!isMobile && hoveredIndex === index ? "scale(1.05)" : "scale(1)"}
							/>
							<Box
								position="absolute"
								top="0"
								left="0"
								right="0"
								bottom="0"
								bg="rgba(0,0,0,0.7)"
								opacity={!isMobile && hoveredIndex === index ? 1 : 0}
								transition="opacity 0.3s ease"
								display="flex"
								alignItems="center"
								justifyContent="center"
							>
								<VStack spacing={4}>
									<Text fontSize="2xl" fontWeight="bold" color="white">
										{project.title}
									</Text>
									<Text fontSize="md" color="gray.300" textAlign="center" px={4} width={"80%"}>
										{project.description}
									</Text>
									<Flex
										gap={2}
										wrap={"wrap"}
										width={"80%"}
										justifyContent={"center"}
									>
										{project.tags.map((tag, tagIndex) => (
											<Tag key={tagIndex} colorScheme="blue" textColor={"white"}>
												{tag}
											</Tag>
										))}
									</Flex>
								</VStack>
							</Box>
						</Box>
					</Link>
				</MotionBox>
				))}
			</SimpleGrid>
		</Flex>
	);
	}
  
  function getGridColumn(index: number) {
    const pattern = [
		"span 3",	// First item spans 3 columns
		"span 2",	// Second item spans 2 columns
		"span 2",	// Third item spans 2 columns
		"span 3",	// Fourth item spans 3 columns
    ];
    return pattern[index % pattern.length];
  }